import { API, LOGIN, FORGOT_PASSWORD, CHANGE_PASSWORD, USERS, ADMIN_CONTEXT } from '../../constants/actions';
import { getToken } from '../../services/local.storage';
import { ERROR_TEXTS } from '../../constants/texts/errors';
import { LOCATION_CHANGE } from 'react-router-redux';
import { userApiDataToState } from '../../selectors/authentication';

const initialState = {
    authenticated: !!getToken(),
    user: {
        email: '',
        fetched: false,
        roles: [],
        permissions: [],
        contextRole: { permissions: [] }
    },
    form: {
        id: '',
        email: '',
        password: '',
        newPassword: '',
        oldPassword: '',
        newPasswordConfirmation: '',
        error: '',
        rememberMe: false,
        submitting: false
    }
};

function authentication(state = initialState, action) {
    switch (action.type) {
        case API.UNAUTHORIZED:
            return initialState;
        case LOGIN.REFRESH:
            return {
                ...state,
                form: { ...initialState.form }
            };
        case LOGIN.INPUT:
        case FORGOT_PASSWORD.INPUT:
        case CHANGE_PASSWORD.INPUT:
            return { ...state, form: { ...state.form, [action.key]: action.value, error: '' } };
        case FORGOT_PASSWORD.FAILED:
        case LOGIN.FAILED:
        case CHANGE_PASSWORD.FAILED:
            return {
                ...state,
                form: { ...state.form, submitting: false, error: ERROR_TEXTS[action.type] }
            };
        case FORGOT_PASSWORD.SUBMIT:
        case CHANGE_PASSWORD.SUBMIT:
        case LOGIN.SUBMIT:
            return { ...state, form: { ...state.form, submitting: true, error: '' } };
        case CHANGE_PASSWORD.SUCCESS:
            return {
                ...state,
                authenticated: true,
                form: initialState.form
            };
        case LOGIN.SUCCESS:
        case USERS.FETCH_OK:
            return {
                ...state,
                authenticated: true,
                form: initialState.form,
                user: {
                    ...state.user,
                    ...userApiDataToState(action.user),
                    fetched: true
                }
            };
        case USERS.UPDATE:
            return {
                ...state,
                user: {
                    ...state.user,
                    [action.field]: action.value
                }
            };
        case ADMIN_CONTEXT.SET:
            return {
                ...state,
                user: {
                    ...state.user,
                    contextRole: action.contextRole
                }
            };
        case LOCATION_CHANGE:
            return { ...state, form: initialState.form };
        case FORGOT_PASSWORD.SUCCESS:
            return { ...state, form: initialState.form, user: { ...state.user, email: action.email } };
        case LOGIN.CANCEL:
            return { ...initialState, authenticated: false };
        default:
            return state;
    }
}

export default authentication;



// WEBPACK FOOTER //
// ./src/reducers/authentication/index.js